



import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

interface IdType { id: string }

@Component
export default class BaseSelect<T extends IdType> extends Vue {
  public options: T[] = [];
  public selectedOption: T | null = null;

  @Prop()
  public value: any;

  @Prop({
    default: true,
  })
  public modelAsId!: boolean;

  @Prop({
    default: false,
  })
  public required!: boolean;

  public get result(): T | null | string {
    if (!this.selectedOption) {
      return null;
    }

    return this.modelAsId ? this.selectedOption.id : this.selectedOption;
  }

  public async getOptions(): Promise<T[]> {
    return [];
  }

  public async mounted(): Promise<void> {
    await this.getOptions();
    this.setModelFromValue();
  }

  @Watch('value')
  public setModelFromValue(): void {
    if (this.options.length === 0) {
      return;
    }
    if (!this.value && this.options.length === 1) {
      this.selectedOption = this.options[0];
      this.$emit('input', this.result);
      return;
    }

    if (this.modelAsId && this.value) {
      this.selectedOption =
        this.options.find((option) => option.id === this.value) || null;
      this.$emit('input', this.result);
    } else if (!this.modelAsId && this.value) {
      this.selectedOption =
        this.options.find((option) => option.id === this.value.id) || null;
      this.$emit('input', this.result);
    }
  }

  public onOptionSelected(): void {
    this.$emit('input', this.result);
  }
}
